import type { ChatStepOption } from '@/lib/postgraduate-chat/chat-flow'
import { OptionPill } from './bubble'

interface ChatOptionsProps {
  readonly options: readonly ChatStepOption[]
  readonly selected?: string
  readonly disabled?: boolean
  readonly onSelect: (value: string) => void
}

export function ChatOptions({ options, selected, disabled = false, onSelect }: ChatOptionsProps) {
  return (
    <div aria-label="Opções de resposta" className="flex flex-wrap gap-1.5" role="group">
      {options.map(option => (
        <OptionPill
          disabled={disabled}
          key={option.value}
          onClick={() => onSelect(option.value)}
          selected={option.value === selected}
        >
          {option.label}
        </OptionPill>
      ))}
    </div>
  )
}
